import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

const normalizeProductFetchError = (response) => {
  if (!response) {
    return null;
  }

  const message =
    response.error || response.message || response.msg || response.data?.error || "";
  const status = response.statusCode ?? response.status;

  if (status === 401 || /http code 401/i.test(message)) {
    return {
      ...response,
      statusCode: 401,
      status: 401,
      message,
      error: message,
    };
  }

  if (status === 404 || /http code 404/i.test(message) || /not found/i.test(message)) {
    return {
      ...response,
      statusCode: 404,
      status: 404,
      message,
      error: message,
    };
  }

  return null;
};

function* getProductsList(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-products?page=" + actions.page
        : apiUrl + "/opa-products" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_PRODUCT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PRODUCT_RESPONSE_GET", value: error });
  }
}

// sagas/sagaProducts.js
function* createProducts(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.data),
    };

    let url = apiUrl + "/opa-product";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCTS_RESPONSE_CREATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {

    yield put({
      type: "PRODUCTS_RESPONSE_CREATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* updateProduct(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.data),
    };

    let url = apiUrl + "/opa-product/" + actions.uuid;

    if (actions.query) {
      url += (url.includes("?") ? "&" : "?") + actions.query;
    }

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCTS_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {

    yield put({
      type: "PRODUCTS_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* getProductsById(actions) {
  let realmUuidLocal = getSetCookie();

  try {
    yield put({
      type: "FETCH_CURRENT_PRODUCT_PENDING",
      requestedUuid: actions.uuid,
    });

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": realmUuidLocal,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-product/${actions.uuid}`;

    if (enviromentUrl) {
      url +=
        (url.includes("?") ? "&" : "?") +
        `env=${enviromentUrl}&include=blackoutDates,customCheckoutQuestions,accessibility,category,extras,images,inclusions,exclusions,notifications,taxes,pricing,waivers,healthSafetyRestrictions,pool`;
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    const normalizedError = normalizeProductFetchError(response);

    if (normalizedError) {
      yield put({
        type: "FETCH_CURRENT_PRODUCT_FAILURE",
        payload: normalizedError,
        requestedUuid: actions.uuid,
      });
      return;
    }

    yield put({
      type: "FETCH_CURRENT_PRODUCT_SUCCESS",
      payload: response,
      requestedUuid: actions.uuid,
    });
  } catch (error) {
    const normalizedError = normalizeProductFetchError(error);

    yield put({
      type: "FETCH_CURRENT_PRODUCT_FAILURE",
      payload: normalizedError || error.message || "Failed to fetch product by ID",
      requestedUuid: actions.uuid,
    });
  }
}

function* duplicateProduct(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.body),
    };

    let url = apiUrl + "/opa-product-duplicate/" + actions.product_uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response[0].uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCTS_RESPONSE_DUPLICATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PRODUCTS_RESPONSE_DUPLICATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* getCabanaList(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-products?page=" + actions.page
        : apiUrl + "/opa-products" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_CABANAS_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_CABANAS_RESPONSE_GET", value: error });
  }
}

/*PRODUCTS*/
export function* getSagaProductsById() {
  yield takeEvery("GET_PRODUCTS_BY_ID", getProductsById);
}

export function* getSagaProductsList() {
  yield takeEvery("GET_PRODUCTS_LIST", getProductsList);
}

export function* getSagaList() {
  yield takeEvery("GET_PRODUCTS_LIST", getProductsList);
}


export function* createSagaProducts() {
  yield takeEvery("CREATE_PRODUCTS", createProducts);
}

export function* updateSagaProduct() {
  yield takeEvery("UPDATE_PRODUCT", updateProduct);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

export function* duplicateSagaProduct() {
  yield takeEvery("DUPLICATE_PRODUCT", duplicateProduct);
}

export function* getSagaCabanaList() {
  yield takeEvery("GET_CABANAS_LIST", getCabanaList);
}
